// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__33WoR","boxTitle":"Qualiphy_boxTitle__2Itv8","box":"Qualiphy_box__1J2rV","toggleWrap":"Qualiphy_toggleWrap__140E7"};